import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthentificationService } from '../services/authentication.service';
import { QRCodeHelper } from '../helpers/qrCodeHelper';
import { ROUTES } from '../constants/routes';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(
    private authService: AuthentificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  canActivate(): boolean {
    const isLoggedIn = this.authService.getAccessToken();

    if (!isLoggedIn) {
      this.activatedRoute.paramMap.pipe(take(1)).subscribe(() => {
        const url = window.location.href.toString().split('?')[1];
        const completeUrl = window.location.href.toString();
        const params = new URLSearchParams(url);
        if (
          window.location.href.includes(ROUTES.LOGIN) &&
          params.get('modul') &&
          params.get('time')
        ) {
          const qrCodeInfo = QRCodeHelper.GenerateQRCodeInfoBasedOnUrlParams(
            params,
            completeUrl
          );
          sessionStorage.setItem('QrCodeInfo', JSON.stringify(qrCodeInfo));
        }
      });

      return true;
    } else {
      this.router.navigate([ROUTES.HOME_BETTING]);
      return false;
    }
  }
}
